/* eslint-disable @typescript-eslint/ban-ts-comment */
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { checkForErrors } from '../../utils/check-for-errors';

export const deleteAsset = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ selectedBot: ProStudioContext['selectedBot'] } | void> => {
  if (event.type !== 'deleteAsset') {
    return;
  }

  const { botName, customerId, selectedBot, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
  }

  const botId = `${customerId}.${botName}`;

  if (!selectedBot) {
    throwErrorWithId('Selected bot is required');
  }

  const response = await urqlGql.deleteBotAsset({
    assetId: encodeURIComponent(event.id),
    botId,
    projectId,
  });

  // Media still writes through Bot Manager (see the note in media-tab.tsx), which has no
  // record of a solution created after the Agent Manager migration — so this can fail. The
  // result used to be ignored, and the row was filtered out of `selectedBot.assets` below
  // regardless: the asset appeared to be deleted and came back on the next `assetsFiles`
  // read. Failing here instead routes to the flow's "Error deleting asset" toast.
  checkForErrors(response);

  return {
    selectedBot: {
      ...ctx.selectedBot,
      assets:
        (ctx.selectedBot?.assets as { id: string; url: string }[])?.filter(
          ({ id }) => id !== event.id
        ) || [],
    },
  };
};
